import { render, staticRenderFns } from "./ResultsAd.vue?vue&type=template&id=3ab3499e&"
import script from "./ResultsAd.vue?vue&type=script&lang=js&"
export * from "./ResultsAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports